import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useFormik } from 'formik'
import PropTypes from 'prop-types'

import Form from '../../../../../components/Form'
import Field from '../../../../../components/Form/Field'
import RoleDescription from './RoleDescription'

import { clearCreateInvite, createInvite } from '../../../../../modules/actions/team'
import {
  inviteCreateErrorSelector,
  inviteCreateIsLoadingSelector,
  inviteWasCreatedSelector
} from '../../../../../modules/selectors/team'
import { selectedPartnershipSelector } from '../../../../../modules/selectors/partnerships'

import { TEAM_MEMBER_CREATE } from '../../../../../constants/forms'
import { initialValues, EMAIL, roleOptions, ROLE } from './fields'
import { validationSchema } from './validation'

import useDrawerFormClasses from '../../../../../styles/common/drawerForms'

const NewUserInviteForm = ({ selfAccountId, isRightsHolderTeam }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const successSubmit = useSelector(inviteWasCreatedSelector)

  const selectedPartnership = useSelector(selectedPartnershipSelector)

  const { rights_holder_name: rightsHolderName } = selectedPartnership

  const drawerFormClasses = useDrawerFormClasses()

  const handleSubmit = values => {
    const { email } = values

    dispatch(createInvite({ email, accounts: [selfAccountId], role: values[ROLE] }))
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSubmit
  })

  const { values } = formik

  const { [ROLE]: role } = values

  const clearCreateNewUserHandler = useCallback(() => {
    dispatch(clearCreateInvite())
  }, [dispatch])

  return (
    <Form
      formName={TEAM_MEMBER_CREATE}
      formik={formik}
      errorSelector={inviteCreateErrorSelector}
      isLoadingSelector={inviteCreateIsLoadingSelector}
      successSubmit={successSubmit}
      clearHandler={clearCreateNewUserHandler}
    >
      <section className={drawerFormClasses.section}>
        <h3 className={drawerFormClasses.sectionTitle}>{t("New member's email")}</h3>
        <Field formik={formik} name={EMAIL} placeholder={t('Enter an email')} />
        <Field placeholder={t('Select user role')} formik={formik} name={ROLE} options={roleOptions} />

        <div className={drawerFormClasses.subSection}>
          <RoleDescription role={role} rightsHolderName={rightsHolderName} isRightsHolderTeam={isRightsHolderTeam} />
        </div>
      </section>
    </Form>
  )
}

NewUserInviteForm.propTypes = {
  selfAccountId: PropTypes.number.isRequired
}

export default NewUserInviteForm
